var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"disabled":_vm.canClip,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"bar-clip wrap",style:('background-color:' + _vm.bgColor + '!important;')},on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }